import React from 'react';
import {Header, Breadcrumb, Icon, Button, Container, Divider, Table, Segment} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import {moneda, stringToDate} from '../../util/index';
import Crossword from '@jaredreisinger/react-crossword';
import { ThemeProvider } from "styled-components";

/*
  
        </Table> 
             
             Vertical
        
             <Table  celled >
                <Table.Header> 
                <Table.Row>
                    <Table.HeaderCell>Pista</Table.HeaderCell>
                    <Table.HeaderCell>Palabra</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Izquierda</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Arriba</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Abajo</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Derecha</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                
                   <Button.Group  >
                <Link to="/crucigramas">
                    <Button  
                        >{strings?strings["regresar"]:""}</Button>
                </Link>
                <Button.Or text=" "></Button.Or>
                <Button  color="black"
                    onClick={onSave}>{strings?strings["guardar"]:""}
                 </Button>
              </Button.Group>
        

*/

const theme = {
  //gridBackground: "rgb(255, 255, 255)",
  //cellBackground: "rgb(255, 150, 150)",
  //focusBackground: "rgb(32,178,170)",
  //highlightBackground: "rgb(255,165,0)",
    //columnBreakpoint: "768px"
    //columnBreakpoint: "300px",
    correct:"rgb(255, 255, 255)"
};

const Juego=({ data, dataArray, moveLeft,  moveRight, moveUp, moveDown, strings, onSave, alertCorrect,referencia, seleccionado, cambio})=>{

   
    
	return (
        <Container >
        
        {dataArray.length>0?
         <Segment>
            <Table  celled >
              <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Posición</Table.HeaderCell>
                    <Table.HeaderCell>Pista</Table.HeaderCell>
                    <Table.HeaderCell>Palabra</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Izquierda</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Arriba</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Abajo</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Derecha</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                {dataArray.map((linea, id) =>


                       <>


                         {linea.posicion=="across"?
                            <Table.Row>
                                <Table.Cell>Horizontal</Table.Cell>    
                                <Table.Cell>{linea.clue}</Table.Cell>
                                <Table.Cell>{linea.answer}</Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button disabled={linea.col==Number(0)?true:false} onClick={()=>moveRight(id,"across")} size="mini" >
                                        <Icon name='arrow alternate circle left' />
                                    </Button>
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button disabled={linea.row==Number(0)?true:false} onClick={()=>moveDown(id,"across")} size="mini">
                                        <Icon name='arrow alternate circle up' />
                                    </Button>         
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button onClick={()=>moveUp(id,"across")} size="mini" ><Icon name='arrow alternate circle down' /></Button>            
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button onClick={()=>moveLeft(id,"across")} size="mini" ><Icon name='arrow alternate circle right' /></Button>    
                                </Table.Cell>        
                            </Table.Row>    


                         :
                                ""
                        }


                        </>



                )}

            
                {dataArray.map((linea, id) =>

                        <>   

                          {linea.posicion=="down"?

                           
                           <Table.Row>
                                <Table.Cell>Vertical</Table.Cell>
                                <Table.Cell>{linea.clue}</Table.Cell>
                                <Table.Cell>{linea.answer}</Table.Cell>
                                <Table.Cell textAlign="center">
                                   <Button disabled={linea.col==Number(0)?true:false} onClick={()=>moveRight(id,"down")} size="mini">
                                        <Icon name='arrow alternate circle left' />
                                    </Button>
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button disabled={linea.row==Number(0)?true:false} onClick={()=>moveDown(id,"down")} size="mini">
                                        <Icon name='arrow alternate circle up' />
                                    </Button>       
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button onClick={()=>moveUp(id,"down")} size="mini"><Icon name='arrow alternate circle down' /></Button>
                                </Table.Cell>
                                <Table.Cell textAlign="center">
                                    <Button onClick={()=>moveLeft(id,"down")} size="mini"><Icon name='arrow alternate circle right' /></Button> 
                                </Table.Cell>        
                            </Table.Row>
                           
                         :
                           ""
                        }


                         </>

                )}
        
            </Table> 
        </Segment>
        :
        
            ""
        
        }
        
        <Divider hidden/>
         
        <br/><br/>
        
        
         <ThemeProvider theme={theme}>
                <Crossword data={data} 
                onCorrect={(direction, number, answer)=>alertCorrect(direction, number, answer)}
                onClueSelected={(direction, number)=>seleccionado(direction, number)}
                ref={referencia}    
                onCellChange={(row,column, character)=>cambio(row,column, character)}
                />
                
                
                
            </ThemeProvider>
      
        
      
        </Container>
	);
};



export default Juego;